import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Observable } from "rxjs";
import { Departments, RimResponse, ListDepartments } from '../reimbursement.interfaces';
import { ReimbursementService } from '../reimbursement.service';
import { DatePipe } from '@angular/common';
import { INgxMyDpOptions } from 'ngx-mydatepicker';
import { FlashService } from '../../flash/flash.service';
import { FormBuilder, FormGroup, FormArray, ValidatorFn, ValidationErrors, Validators, FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-reimbursement-add-form',
  templateUrl: './reimbursement-add-form.component.html',
  styleUrls: ['./reimbursement-add-form.component.css']
})
export class ReimbursementAddFormComponent implements OnInit {
  user;
  total;
  sum = 0;
  submit = false;
  statusKey;
  departments: Observable<Departments>;
  categories: Observable<Departments>;
  status: ListDepartments[];
  userData: RimResponse;
  addForm: FormGroup;
  expensesForm: FormGroup;
  myOptions: INgxMyDpOptions = {
    dateFormat: 'yyyy-mm-dd'
  };
  index_item: any[] = [];
  k;
  attachments;
  i;
  currentDate;
  isSelected: boolean
  paymentTypes = [
    {
      'key': 'Cash',
      'value': 'Cash'
    },
    {
      'key': 'Google Pay',
      'value': 'Google Pay',
    }, {
      'key': ' Phone Pe',
      'value': 'Phone Pe',
    },
    {
      'key': 'NEFT/IMPS',
      'value': 'NEFT',
    }
  ]
  @ViewChild('closeModal') close: ElementRef;
  invalidError: boolean;
  constructor(private reimbur: ReimbursementService, private location: Location, private datepipe: DatePipe,
    private formBuilder: FormBuilder, private flashService: FlashService,
    private router: Router, private spinnerService: Ng4LoadingSpinnerService,

  ) {
    // this.departments = this.reimbur.getDepartments();
    this.categories = this.reimbur.getCategories();
    this.getStatusList();
  }

  selectInput(event) {
    let selected = event.target.value;
    if (selected == "Cash") {
      this.isSelected = true;
      this.addForm.controls.payment_details.clearValidators();
      this.addForm.controls.payment_details.updateValueAndValidity();

    } else {
      this.isSelected = false;
      this.addForm.controls.payment_details.setValidators(Validators.required);
      this.addForm.controls.payment_details.updateValueAndValidity();
    }
  }

  getStatusList() {
    this.reimbur.getListStatus().subscribe(status => {
      status.filter(status => {
        if (status.key === "submitted") {
          this.statusKey = (status.key);
        }
      });
    });
  }


  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    this.addForm = this.formBuilder.group({
      'id': this.user.id,
      'purpose': ['', Validators.required],
      'from_date': ['', [Validators.required]],
      'to_date': ['', Validators.required],
      'payment_type': ['', Validators.required],
      'payment_details': ['', Validators.required],
      'items': this.formBuilder.array([this.itemArray()])
    }, { validator: this.checkDates('from_date', 'to_date') }
    )
  }

  trackByFn(index) {
    return index;
  }

  public checkDates(startKey: string,
    endKey: string): ValidatorFn {
    return (group: FormGroup): ValidationErrors => {
      const startDate = group.controls[startKey];
      const endDate = group.controls[endKey];
      if (startDate.value !== '' && endDate.value !== '') {
        startDate.setErrors(null);
        endDate.setErrors(null);
        const d_startDate = new Date(startDate.value.formatted);
        const d_endDate = new Date(endDate.value.formatted);
        const d_currentDate = new Date();
        let startValid = true;
        let endValid = true;
        if (startDate.value !== '') {
          if (d_startDate > d_currentDate) {
            startDate.setErrors({ 'type': 'startDateLess', 'message': 'Start Date should be less than Current Date.' });
            startValid = false;
          }
        }
        if (endDate.value !== '') {
          if (d_endDate > d_currentDate) {
            endDate.setErrors({ 'type': 'endtDateLess', 'message': 'End Date should be less than Current Date.' });
            endValid = false;
          }
        }
        if (startDate.value !== '' && endDate.value !== '' && startValid && endValid) {
          if (d_startDate > d_endDate) {
            startDate.setErrors({ 'type': 'startDateLess', 'message': 'Start Date should be less than End Date.' });
            endDate.setErrors({ 'type': 'startDateLess', 'message': 'End Date should be greater than Start Date.' });
          }
        }
      }
      return;
    };
  }

  checkDatesItems(date: string): ValidatorFn {
    return (group: FormGroup): ValidationErrors => {

      const itemDate = group.controls[date];

      if (itemDate.value !== '') {
        itemDate.setErrors(null);
        const d_ItemDate = new Date(itemDate.value.formatted);
        const currentDate = new Date();
        let itemDateValid = true;
        let fromdateValid = true;
        let todateValid = true;
        if (itemDate.value !== '') {
          if (d_ItemDate > currentDate) {
            itemDate.setErrors({ 'type': 'startDateLess', 'message': 'Item Date should be less than Current Date.' });
            itemDateValid = false;
          }
        }

        const d_startDate = new Date(this.addForm.controls['from_date'].value.formatted);
        const d_endDate = new Date(this.addForm.controls['to_date'].value.formatted);

        if (itemDate.value !== '' && this.addForm.controls['from_date'].value !== '' && this.addForm.controls['to_date'].value !== '') {

          if (d_ItemDate < d_startDate) {

            itemDate.setErrors({ 'type': 'startDateLess', 'message': 'Item Date should be give inbetween from_Date to_date.' });
            fromdateValid = false;
          }
          if (d_ItemDate > d_endDate) {

            itemDate.setErrors({ 'type': 'startDateLess', 'message': 'Item Date should be give inbetween from_Date to_date.' });
            todateValid = false;
          }
        }
      }
      return;
    }
  }

  itemArray() {
    return this.formBuilder.group({
      'date': ['', Validators.required],
      'description': ['', Validators.required],
      'category': ['', Validators.required],
      'cost': ['', Validators.required],
      'attachments': this.formBuilder.array([], Validators.required)
    }, { validator: this.checkDatesItems('date') })
  }



  locationBack() {
    this.location.back();
  }


  dateString(value) {
    const dateString = value.date.year + '-' +
      (value.date.month < 9 ? '0' : '') + value.date.month + '-' +
      (value.date.day < 10 ? '0' : '') + value.date.day;
    return dateString;
  }

  attachGroup(data) {
    return this.formBuilder.group({
      'key': data.key,
      'name': data.name,
      'url': data.url
    })
  }
  removeAttachment(index): void {
    const arrayControl = <FormArray>this.addForm.controls['items'];
    arrayControl.removeAt(index);
  }
  get ExpensesitemArray() {
    return this.addForm.get('items') as FormArray;
  }

  addExpensesItems() {
    this.ExpensesitemArray.push(this.itemArray());
  }

  getFileDetails(e, index) {
    this.index_item = index;
    const frmData = new FormData();
    this.spinnerService.show();
    for (var i = 0; i < e.target.files.length; i++) {
      frmData.append("file", e.target.files[i]);
    }

    if (e.target.files.length) {
      this.reimbur.getUploadFile(frmData).subscribe(files => {
        this.spinnerService.hide();
        files.forEach(filesData => {
          this.ExpensesitemArray.controls[index]['controls'].attachments.push(this.attachGroup(filesData))
        });
      }, error => {
        this.spinnerService.hide();
      });
    };
  }

  onSubmit(formData) {
    this.validateAllFields(this.addForm);
    if (this.submit) {
      if (this.addForm.valid) {
        formData.value.from_date = formData.value.from_date.formatted;
        formData.value.to_date = formData.value.to_date.formatted
        formData.value.items.forEach(dateFormat => {
          if (typeof dateFormat.date == "object") {
            dateFormat.date = dateFormat.date.formatted;
          } else {
            dateFormat.date = dateFormat.date.formatted;
          }
        });

        this.reimbur.getUser(formData.value, this.statusKey).subscribe(userDetail => {
          this.userData = userDetail;
          this.flashService.show(userDetail['message'], 'alert-success');
          this.router.navigate(['/reimbursement/list']);
        });
      }

    }
    else {
      if (this.addForm.valid) {
        formData.value.from_date = formData.value.from_date.formatted;
        formData.value.to_date = formData.value.to_date.formatted
        formData.value.items.forEach(dateFormat => {
          if (typeof dateFormat.date == "object") {
            dateFormat.date = dateFormat.date.formatted;
          } else {
            dateFormat.date = dateFormat.date;
          }
        });

        this.reimbur.getSaveUser(formData.value).subscribe(userDetail => {
          this.userData = userDetail;

          this.flashService.show(userDetail['message'], 'alert-success');
          this.router.navigate(['/reimbursement/list']);
        });
      }
    }
  }

  validateAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormArray) {
        if (control instanceof FormArray && field === 'attachments') {
          control.markAsDirty();
        }
        for (const control1 of control.controls) {
          if (control1 instanceof FormControl) {
            control1.markAsTouched({
              onlySelf: true
            });
          }
          if (control1 instanceof FormGroup) {
            this.validateAllFields(control1);
          }

        }
      }
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      } else if (control instanceof FormGroup) {
        this.validateAllFields(control);
      }
    });
  }




  totalCost() {
    this.sum = 0;
    this.total = this.addForm.value.items;
    for (let j = 0; j < this.total.length; j++) {
      this.sum += Number(this.total[j].cost);
    }
  }

  removeFiles(k, attachment, i) {
    this.k = k;
    this.attachments = attachment;
    this.i = i;
  }

  delete() {
    if (this.attachments.value.key) {
      let key = [];
      key.push(this.attachments.value.key);
      this.reimbur.deleteUploadFile(key).subscribe(response => {

        this.ExpensesitemArray.controls[this.i]['controls']['attachments'].controls.splice(this.k, 1);
        let attachmentValues = this.ExpensesitemArray.controls[this.i]['controls']['attachments'].value;
        let deleteElement = attachmentValues.splice(this.k, 1);
        this.ExpensesitemArray.controls[this.i]['controls']['attachments'].patchValue(attachmentValues);
        this.close.nativeElement.click();
        this.flashService.show(response['message'], 'alert-success')
      });
    }
  }
  saveForUser() {
    this.submit = false;
  }

  submitForUser() {
    this.submit = true;
  }
}


// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/reimbursement/reimbursement-add-form/reimbursement-add-form.component.ts